import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';

import { Message } from 'src/app/chat-ai/models/chat-ai.models';

import { cloneDeep } from 'lodash';

export interface IChatState {
    messages: Message[];
    canSendMessage: boolean;
}

export const DEFAULT_STATE: IChatState = {
    messages: [],
    canSendMessage: true
};

@Injectable()
export class ChatAiStateService {
    public readonly $messages: Signal<Message[]> = computed(() => this.$state().messages);
    public readonly $canSendMessage: Signal<boolean> = computed(() => this.$state().canSendMessage);

    private readonly $state: WritableSignal<IChatState> = signal<IChatState>(cloneDeep(DEFAULT_STATE));

    public setMessages(messages: Message[], canSendMessage = true): void {
        this.updateState(state => {
            state.messages = messages;
            state.canSendMessage = canSendMessage;
        });
    }

    public updateWithBotStreamingMessage(botMessage: Message, canSendMessage = false): void {
        this.updateState(state => {
            state.messages[state.messages.length - 1] = botMessage;
            state.canSendMessage = canSendMessage;
        });
    }

    public updateWithNewUserMessage(userMessage: Message, botMessage: Message): void {
        this.updateState(state => {
            state.messages.push(userMessage);
            state.messages.push(botMessage);
            state.canSendMessage = false;
        });
    }

    private updateState(stateUpdateHandler: (state: IChatState) => void): void {
        this.$state.update(state => {
            const newState: IChatState = cloneDeep(state);
            stateUpdateHandler(newState);

            return newState;
        });
    }
}
